import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

// Confirmation dialog shown when leaving the builder with unsaved changes.
const LeaveFlowDialog = ({ open, busy, onSaveAndLeave, onDiscard, onCancel }) => (
  <Dialog open={open} onClose={onCancel} maxWidth='xs' fullWidth>
    <DialogTitle>Änderungen speichern?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Es gibt ungespeicherte Änderungen in diesem Flow. Sollen sie vor dem Verlassen gespeichert
        werden?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Abbrechen</Button>
      <Button color='error' onClick={onDiscard}>
        Verwerfen
      </Button>
      <Button variant='contained' disabled={busy} onClick={onSaveAndLeave}>
        Speichern und verlassen
      </Button>
    </DialogActions>
  </Dialog>
);

export default LeaveFlowDialog;
